module.exports = __webpack_public_path__ + "static/media/Teil_2_Backward.0ce01970.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/Teil_2_Backward.mp4
// module id = 114
// module chunks = 0